import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { getAppValue } from "src/utils/environment";
import SvgContainer from "src/components/SvgContainer";
import { Caption, Subtitle, BodyText2 } from "src/atoms/typography";
import time from "src/utils/time";
import { ReactComponent as ZzzIcon } from "src/modules/activity-log/icons/zzz.svg";

export default function SleepingEvent({
  startTimeColumnWidth,
  avatar,
  activityLogType,
  formattedStartTime,
  event
}) {
  const { t } = useTranslation();
  const { duration } = event;
  let eventText;
  if (activityLogType === "live") {
    if (avatar && avatar.sex === "female") {
      eventText = t("femaleSleeping");
    } else eventText = t("maleSleeping");
  } else {
    if (avatar) {
      eventText = t(
        avatar.sex === "male" ? "maleWasSleeping" : "femaleWasSleeping",
        {
          value0: avatar.name
        }
      );
    } else eventText = t("avatarWasSleeping");
  }

  return (
    <Flex alignItems="center" height="36px">
      <Caption
        textAlign="right"
        mr="16px"
        color="mediumEmphasis"
        width={startTimeColumnWidth + "px"}
        flex="0 0 auto"
      >
        {formattedStartTime}
      </Caption>
      <SvgContainer
        mr="16px"
        fill={getAppValue({ barkio: "primary", bibino: "secondary" })}
        icon={ZzzIcon}
        size="20px"
      />
      <Flex flexDirection="column">
        <Subtitle
          color="highEmphasis"
          maxWidth={activityLogType === "live" ? "96px" : "220px"}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {eventText}
        </Subtitle>
        <BodyText2 mt="3px" lineHeight={1} color="mediumEmphasis">
          {time.duration(duration).format("h _ m _ s _")}
        </BodyText2>
      </Flex>
    </Flex>
  );
}
